import axiosConfig from './axiosConfig';

export type ProjectLevelEmailConfigFeatures = Record<string, boolean>;

export interface ProjectLevelEmailConfig {
  email_config_id: number;
  project_id: number;
  email: string;
  features: ProjectLevelEmailConfigFeatures;
  created_by?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface CreateProjectLevelEmailConfigPayload {
  project_id: number;
  email: string;
  features: ProjectLevelEmailConfigFeatures;
  created_by?: string;
}

export interface UpdateProjectLevelEmailConfigPayload {
  email?: string;
  features?: ProjectLevelEmailConfigFeatures;
}

function unwrapData<T>(responseData: any): T {
  if (Array.isArray(responseData)) return responseData as T;
  if (responseData?.data != null) return responseData.data as T;
  return responseData as T;
}

export async function listProjectLevelEmailConfigs(
  projectId: number
): Promise<ProjectLevelEmailConfig[]> {
  const response = await axiosConfig.get('project/projectLevelEmailConfig', {
    params: { projectId },
  });
  const data = unwrapData<ProjectLevelEmailConfig[]>(response.data);
  return Array.isArray(data) ? data : [];
}

export async function createProjectLevelEmailConfig(
  payload: CreateProjectLevelEmailConfigPayload
): Promise<ProjectLevelEmailConfig> {
  const response = await axiosConfig.post('project/projectLevelEmailConfig', payload);
  return unwrapData<ProjectLevelEmailConfig>(response.data);
}

export async function updateProjectLevelEmailConfig(
  id: number,
  payload: UpdateProjectLevelEmailConfigPayload
): Promise<ProjectLevelEmailConfig> {
  const response = await axiosConfig.put(`project/projectLevelEmailConfig/${id}`, payload);
  return unwrapData<ProjectLevelEmailConfig>(response.data);
}

export async function deleteProjectLevelEmailConfig(id: number): Promise<void> {
  await axiosConfig.delete(`project/projectLevelEmailConfig/${id}`);
}
